import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            'odatv.com',
            'google',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            'odatv.com',
            'google',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'tr.mashable.com',
                value: 'tr.mashable.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Güncel', value: 'güncel' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Spor', value: 'yaşam' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Arşiv', value: 'arşiv' },
            { label: 'Son Dakika Haberleri', value: 'son dakika haberleri' },
            { label: 'Yaşam', value: 'yaşam' },
            { label: 'Magazin', value: 'magazin' },
            { label: 'Sağlık', value: 'sağlık' },
            { label: 'Analiz', value: 'analiz' },
            { label: 'Diğer Haberler', value: 'diğer haberler' },
            { label: 'Kültür - Sanat', value: 'kültür - sanat' },
            { label: 'Siyaset', value: 'siyaset' },
            { label: 'Medya', value: 'medya' },
            { label: 'Bilim ve Teknoloji', value: 'bilim ve teknoloji' },
            { label: 'Eğitim', value: 'eğitim' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Soner Yalçın', value: 'soner yalçın' },
            { label: 'Ayşe Baykal', value: 'ayşe baykal' },
            { label: 'Can Özçelik', value: 'can özçelik' },
            { label: 'Elçin Demiröz', value: 'elçin demiröz' },
            { label: 'Kaan Çağlayangöl', value: 'kaan çağlayangöl' },
            { label: 'Mert Taşçılar', value: 'mert taşçılar' },
            { label: 'Hikmet Çiçek', value: 'hikmet çiçek' },
            { label: 'Kayahan Uğur', value: 'kayahan uğur' },
            { label: 'Gülnihal Özdener', value: 'gülnihal özdener' },
            { label: 'Kaan Arslanoğlu', value: 'kaan arslanoğlu' },
            { label: 'Burcu Bostancıoğlu', value: 'burcu bostancıoğlu' },
            { label: 'Sina Koloğlu', value: 'sina koloğlu' },
            { label: 'Pınar Saraçoğlu', value: 'pınar Saraçoğlu' },
            { label: 'Uğur Can Biçer', value: 'uğur can biçer' },
            { label: 'Hüseyin Nazlıkul', value: 'hüseyin nazlıkul' },
            { label: 'Elif Aktuğ', value: 'elif aktuğ' },
            { label: 'Odabudsman', value: 'odabudsman' },
            { label: 'Suat Çağlayan', value: 'suat çağlayan' },
            { label: 'Salih Seçkin Sevinç', value: 'salih seçkin sevinç' },
            { label: 'Yusuf İleri', value: 'yusuf ileri' },
            { label: 'Fehmi Köfteoğlu', value: 'fehmi köfteoğlu' },
            { label: 'Cüneyt Ülsever', value: 'cüneyt ülsever' },
            { label: 'Mustafa Önsel', value: 'mustafa önsel' },
            { label: 'Servet Seyfettin Mete', value: 'servet seyfettin mete' },
            { label: 'Ayşe Deniz', value: 'ayşe deniz' },
            { label: 'Coşkun Musluk', value: 'coşkun musluk' },
            { label: 'Meclis Kulisi', value: 'meclis kulisi' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Oda TV Editör 1', value: 'oda tv editör 1' },
            { label: 'Oda TV Editör 2', value: 'oda tv editör 2' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterOdatvObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
